module.exports = __webpack_public_path__ + "img/busca-planos.0199962b.svg";